import { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import {
  beginTenantLogin, configureTenantAuth, establishTenantSession,
  tenantLoginDestination, tenantPasskeyEnrollmentUrl,
} from '../../lib/tenant-auth';

export function TenantLoginPage() {
  const [params] = useSearchParams();
  const [error, setError] = useState<string | null>(null);
  const [ready, setReady] = useState(false);
  const tenantId = params.get('tenant');
  const requestedDestination = params.get('destination');
  const destination = safeLocalDestination(requestedDestination) ??
    (tenantId ? `/t/${encodeURIComponent(tenantId)}` : '/');
  useEffect(() => { configureTenantAuth().then(() => setReady(true)).catch(show(setError)); }, []);
  return <main className="mx-auto max-w-md px-6 py-20">
    <h1 className="mb-3 font-serif text-3xl">Tenant sign-in</h1>
    <p className="mb-6 text-neutral-600">Sign in with your organization account.</p>
    {error && <p role="alert" className="mb-4 text-red-800">{error}</p>}
    <button disabled={!ready} onClick={() => beginTenantLogin(destination).catch(show(setError))}
      className="rounded bg-neutral-900 px-4 py-2 text-white disabled:opacity-50">Continue to sign in</button>
  </main>;
}

export function TenantCallbackPage() {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const [ready, setReady] = useState(false);
  useEffect(() => { configureTenantAuth().then(establishTenantSession).then(() => setReady(true)).catch(show(setError)); }, []);
  if (error) return <main className="mx-auto max-w-md px-6 py-20">
    <p role="alert" className="mb-4 text-red-800">{error}</p>
    <Link className="underline" to={`/tenant/login?destination=${encodeURIComponent(tenantLoginDestination())}`}>
      Try signing in again or use a different account
    </Link>
  </main>;
  if (!ready) return <main className="mx-auto max-w-md px-6 py-20">Completing sign-in…</main>;
  return <main className="mx-auto max-w-md px-6 py-20">
    <h1 className="mb-3 font-serif text-3xl">You’re signed in</h1>
    <p className="mb-6 text-neutral-600">If this device does not yet have a passkey, enroll one now.</p>
    <div className="flex gap-3">
      <a className="rounded bg-neutral-900 px-4 py-2 text-white" href={tenantPasskeyEnrollmentUrl()}>Enroll passkey</a>
      <button className="rounded border border-neutral-300 px-4 py-2" onClick={() => navigate(tenantLoginDestination())}>Continue</button>
    </div>
  </main>;
}
function show(setter: (message: string) => void) {
  return (reason: unknown) => setter(reason instanceof Error ? reason.message : 'Tenant sign-in failed.');
}

function safeLocalDestination(value: string | null): string | null {
  return value?.startsWith('/') && !value.startsWith('//') ? value : null;
}
